<img *ngIf="imageSource" [src]="imageSource" (load)="imageLoaded()" />

<!-- Absolute -->
<app-circle-loader *ngIf="isLoading" class="loader">
</app-circle-loader>
<div class="filename">{{document.nomFichier}}</div>
<p *ngIf="isOther" class="extension">{{document.extension}}</p>